module.exports = __webpack_public_path__ + "static/img/1024_small.6f8b922.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1024_small.png
// module id = zNy/
// module chunks = 1